<template>
  <div class="container-fluid">
    <div class="row">
      <div class="nav-cookies">
        <div class="cookies">
          <div class="container">
            <p
              class="cookie-consent-text"
              v-html="$t('cookie.cookie_consent')"
            />
            <a
              class="cookie-accept"
              href="#"
              @click="add_tracking"
            >
              <i
                class="fa fa-check-circle"
                v-html="$t('cookie.continue')"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    add_tracking: function(event) {
      event.preventDefault()
      document.cookie = `tracking=true;expires=${new Date(new Date().getTime()+365*60*60*1000*24).toGMTString()}`
      $('.cookies').slideUp()
      $('.navbar').animate({ top: '0' })
      $('body').removeClass('cookie-consent-dropdown')
    }
  }
}
</script>
